import { ASSISTANT_ENABLED } from '../constants'

const initialState = {
    assistantEnabled: false
}

/**
 * Reducer to update a global copy of the 'showAssistant' state. This allows components like
 * ProductDetails.js to update when the assistant is enabled or disabled.  Note that this is
 * a copy of the state, and not the actual source of truth used by BotAssistant.js or
 * BotAssistantMobile.js.  These components maintain their 'showAssistant' state internally to
 * prevent potentially problematic re-invocations of componentWillReceiveProps.
 */
const assistant = (state = initialState, action) => {
    switch (action.type) {
        case ASSISTANT_ENABLED:
            return {
                ...state,
                assistantEnabled: action.assistantEnabled
            }
        default:
            return state
    }
}

export default assistant



// WEBPACK FOOTER //
// ./src/reducers/assistant.js